import { Injectable, OnDestroy, OnInit } from '@angular/core';
import { Product } from '../Model/product';
import { LocalStorageService } from './local-storage.service';
import { GoogleCustomer } from '../Model/googlecustomer';
import { Observable, Subscription } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ApiFactoryEndPoints } from '../common/api-factory-end-points';
import { ToastService } from './toast.service';
import { CartDetails } from '../Model/cart-details';
import { OrderSummary } from '../Model/order-summary';
import { BulkDiscountDto } from '../Model/bulk-discount-dto';

@Injectable({
  providedIn: 'root'
})
export class ProductService {

  googleCustomer: GoogleCustomer;
  currentUrl: string;
  orderSummary: OrderSummary;
  pincode: number;

  private cartSetUpSubscription: Subscription;

  constructor(
    private localStorage: LocalStorageService,
    private http: HttpClient,
    private apiFactory: ApiFactoryEndPoints,
    private toastrService: ToastService
  ) {
    this.currentUrl = window.location.host.replace(':', '');
  }

  ngOnDestroy(): void {
    if (this.cartSetUpSubscription != undefined) {
      this.cartSetUpSubscription.unsubscribe();
    }
  }

  // Fetching Locat CartsProducts
  getLocalCartProducts(): Product[] {
    const products: Product[] = JSON.parse(this.localStorage.getItem("avct_item")) || [];
    // products.forEach((element) => {
    // if (element.cartProductType == "Make To Order") {
    //   const today = new Date();
    //   if (new Date(element.deliveryDate) < today) {
    //     const tomorrow = new Date(today.setDate(today.getDate() + (element.minimum_Order_Time ? element.minimum_Order_Time : 0)));
    //     element.deliveryDate = moment(tomorrow.toString()).format("YYYY-MM-DD");
    //   }
    // }
    // });
    this.localStorage.setItem("avct_item", JSON.stringify(products));
    return products;
  }

  removeAllProductsFromCart(removedProducts: Product[], updatedProducts: Product[]): void {
    this.googleCustomer = JSON.parse(this.localStorage.getItem("google_loggedIn_details"));

    if (this.googleCustomer) {
      const productIds = removedProducts.map(p => p.product_Code);

      this.cartSetUpSubscription = this.removeAllProductCart(
        this.apiFactory.removeAllProductFromCart,
        this.googleCustomer.email,
        productIds, this.currentUrl
      ).subscribe((data: any) => {

        // After API call, update the local storage with the remaining valid products
        this.localStorage.setItem("avct_item", JSON.stringify(updatedProducts));
      });
    } else {
      // If not logged in, just update local storage with the valid products
      this.localStorage.setItem("avct_item", JSON.stringify(updatedProducts));
    }

    // Show an alert listing removed products
    this.toastrService.showWarningToast(`Some products were removed due to insufficient shelf life: ${removedProducts.map(p => p.product_Name).join(', ')}`);
  }

  removeAllProductCart(url: string, email: string, id: number[], currrentUrl: string) {
    return this.http.post<any>(url + "/" + email + "/" + id + "/" + currrentUrl, {
      responseType: "text",
    });
  }

  getSystemAndManualStockDetails(url: string, locId: number, productCode: number[], currentUrl: string, deliveryTye: string) {
    return this.http.get<any>(
      url + "/" + locId + "/" + currentUrl + "/" + deliveryTye + "/" + productCode
    );
  }
  cartDetails: CartDetails = new CartDetails();

  // addToCart1(data: Product): void {
  //   console.log(data);

  //   this.googleCustomer = JSON.parse(this.localStorage.getItem("google_loggedIn_details"));
  //   let locationCode: number = JSON.parse(this.localStorage.getItem("location_code"));
  //   const a: Product[] = JSON.parse(this.localStorage.getItem("avct_item")) || [];

  //   if (a.some((temp) => temp.product_Code == data.product_Code && temp.cartProductType == "Product")) {
  //     data.orderQuantity = 1;
  //     data.discountAmt = 0;
  //     if (data.cartProductType == "Product") {
  //       data.basePremiumFlavourPrice = 0;
  //       data.premiumFlavourPrice = 0;
  //     }
  //     var taxableAmt = data.sale_Price - (data.sale_Price * data.discountAmt) / 100;
  //     taxableAmt = taxableAmt + data.basePremiumFlavourPrice;
  //     var cgst = (data.tax.taxRate / 2 / 100) * taxableAmt;
  //     data.cgstAmt = cgst;
  //     var sgst = (data.tax.taxRate / 2 / 100) * taxableAmt;
  //     data.sgstAmt = sgst;
  //     data.taxAmount = cgst + sgst; //Tax Amount
  //     data.cessAmount = (data.cess.cessRate / 100) * taxableAmt;
  //     a.push(data);

  //     var productList: any = [];

  //     if (this.googleCustomer != null) {
  //       a.forEach((element) => {
  //         element.status = "Not placed";
  //         if (element.cartProductType == "Product") {
  //           productList.push(element);
  //         }
  //       });

  //       this.cartDetails.status = "Not placed";
  //       this.cartDetails.logInCustomerEmail = this.googleCustomer.email;
  //       this.cartDetails.locationCode = locationCode;
  //       this.cartDetails.product = productList;
  //     }

  //     if (productList.length != 0) {
  //       this.cartSetUpSubscription = this.insertCartSetUp(this.apiFactory.insertProductCart, this.cartDetails)
  //         .subscribe((response: any) => { });
  //     }

  //     this.toastrService.wait("Adding Product to Cart", data.product_Name + " added to cart");
  //     setTimeout(() => {
  //       this.localStorage.setItem("avct_item", JSON.stringify(a));
  //     }, 500);
  //   }
  // }

  // Adding new Product to cart db if logged in else localStorage
  addToCart1(data: Product): void {

    this.googleCustomer = JSON.parse(this.localStorage.getItem("google_loggedIn_details"));

    let locationCode: number = JSON.parse(this.localStorage.getItem("location_code"));

    // this.getCartProduct(data);
    // console.log(this.cartList)

    const a: Product[] = JSON.parse(this.localStorage.getItem("avct_item")) || [];

    if (a.some((temp) => temp.product_Code == data.product_Code && temp.cartProductType == "Make To Order")) {
      let itemIndex = a.findIndex((item) => item.product_Code == data.product_Code);
      data.orderQuantity = 1;
      data.discountAmt = 0;
      var taxableAmt = data.sale_Price - (data.sale_Price * data.discountAmt) / 100;
      taxableAmt = taxableAmt + data.basePremiumFlavourPrice;
      var cgst = (data.tax.taxRate / 2 / 100) * taxableAmt;
      data.cgstAmt = cgst;
      var sgst = (data.tax.taxRate / 2 / 100) * taxableAmt;
      data.sgstAmt = sgst;
      data.taxAmount = cgst + sgst;
      data.cessAmount = (data.cess.cessRate / 100) * taxableAmt;
      a[itemIndex] = data;
      this.localStorage.setItem("avct_item", JSON.stringify(a));

      var mtoList1: any = [];

      if (this.googleCustomer != null) {
        a.forEach((element) => {
          if (element.cartProductType == "Make To Order") {
            element.status = "Not placed";
            mtoList1.push(element);
          }
        });

        // this.mtoCartDetails.status = "Not placed";
        // this.mtoCartDetails.logInCustomerEmail = this.googleCustomer.email;
        // this.mtoCartDetails.locationCode = locationCode;
        // this.mtoCartDetails.product = mtoList1;
      }

      // if (mtoList1.length != 0) {
      //   this.cartSetUpSubscription = this.userService.addProductToCartWithFiles(this.apiFactory.insertMakeToOrderCart, this.mtoCartDetails)
      //     .subscribe((response: any) => { });
      // }
      this.toastrService.showSuccessToast(data.product_Name + " updated");
    } else {
      if (a.some((temp) => temp.product_Code == data.product_Code && !temp.freeByProductCode)) {
        // this.toastrService.showErrorToast(data.product_Name + " is already added to cart");
      } else {
        data.orderQuantity = 1;
        data.discountAmt = 0;
        if (data.cartProductType == "Product") {
          data.basePremiumFlavourPrice = 0;
          data.premiumFlavourPrice = 0;
        }
        var taxableAmt = data.sale_Price - (data.sale_Price * data.discountAmt) / 100;
        taxableAmt = taxableAmt + data.basePremiumFlavourPrice;
        var cgst = (data.tax.taxRate / 2 / 100) * taxableAmt;
        data.cgstAmt = cgst;
        var sgst = (data.tax.taxRate / 2 / 100) * taxableAmt;
        data.sgstAmt = sgst;
        data.taxAmount = cgst + sgst; //Tax Amount
        data.cessAmount = (data.cess.cessRate / 100) * taxableAmt;
        a.push(data);
        //save Cart Data to Mongo DB
        // this.cartDetails.product = a;

        var productList: any = [];
        var mtoList: any = [];

        // if (this.googleCustomer != null) {
        a.forEach((element) => {
          element.status = "Not placed";
          if (element.cartProductType == "Product") {
            productList.push(element);
          } else {
            mtoList.push(element);
          }
        });

        this.cartDetails.status = "Not placed";
        this.cartDetails.logInCustomerEmail = this.googleCustomer?.email;
        this.cartDetails.locationCode = locationCode;
        this.cartDetails.currentUrl = this.currentUrl;
        this.cartDetails.product = productList;

        // this.mtoCartDetails.status = "Not placed";
        // this.mtoCartDetails.logInCustomerEmail = this.googleCustomer.email;
        // this.mtoCartDetails.locationCode = locationCode;
        // this.mtoCartDetails.product = mtoList;
        // }
        if (productList.length != 0) {
          this.cartSetUpSubscription = this.insertCartSetUp(this.apiFactory.insertProductCart, this.cartDetails)
            .subscribe((response: any) => { });
        }

        // if (mtoList.length != 0) {
        //   this.cartSetUpSubscription = this.userService.addProductToCartWithFiles(this.apiFactory.insertMakeToOrderCart, this.mtoCartDetails)
        //     .subscribe((response: any) => { });
        // }

        this.toastrService.wait("Adding Product to Cart", data.product_Name + " added to cart");
        setTimeout(() => {
          this.localStorage.setItem("avct_item", JSON.stringify(a));
          // this.getCartProduct(data);
        }, 500);
      }
    }
  }

  insertCartSetUp(url: string, req: CartDetails) {
    return this.http.post(url, req, { responseType: "json" });
  }

  // Removing cart from local
  removeLocalCartProduct(product: Product) {
    this.googleCustomer = JSON.parse(this.localStorage.getItem("google_loggedIn_details"));
    const products: Product[] = JSON.parse(this.localStorage.getItem("avct_item"));

    // for (let i = 0; i < products.length; i++) {
    //   if (products[i].product_Code === product.product_Code) {
    //     products.splice(i, 1);
    //   } else if (products[i].designForProductCode === product.product_Code) {
    //     console.log(products[i]);
    //     products.splice(i, 1);
    //     console.log(products[i]);
    //   }
    // }

    let index = products.findIndex(e => e.product_Code === product.product_Code && !e.designForProductCode && !e.freeByProductCode);
    if (index >= 0)
      products.splice(index, 1);
    let designIndex = products.findIndex(e => e.designForProductCode === product.product_Code);
    if (designIndex >= 0)
      products.splice(designIndex, 1);
    let offerIndex = products.findIndex(e => e.freeByProductCode === product.product_Code);
    if (offerIndex >= 0)
      products.splice(offerIndex, 1);

    if (this.googleCustomer != null) {
      if (product.cartProductType == "Product") {
        this.currentUrl = window.location.host.replace(':', '');
        this.cartSetUpSubscription = this.removeProductCart(this.apiFactory.removeProductFromCart, this.googleCustomer.email, product.product_Code, this.currentUrl)
          .subscribe((data: any) => { });
      }
      // else {
      //   this.cartSetUpSubscription = this.removeProductCart(this.apiFactory.removeMtoProductFromCart, this.googleCustomer.email, product.product_Code)
      //     .subscribe((response: any) => { });
      // }
    }

    // ReAdding the products after remove
    this.localStorage.setItem("avct_item", JSON.stringify(products));
  }

  removeProductCart(url: string, email: string, id: number, currentUrl: string) {
    return this.http.post<any>(url + "/" + email + "/" + id + "/" + currentUrl, {
      responseType: "json",
    });
  }

  getLocalCartProductLength() {
    return this.getLocalCartProducts().filter(e => !e.designForProductCode).length;
  }

  checkPincode(url: string, pincode: number, currentUrl: string) {
    return this.http.get<boolean>(url + "/" + pincode + "/" + currentUrl);
  }

  signOutUser(url: string, token: string) {
    return this.http.get<any>(url + '/' + token);
  }

  getAggregatorSetup(api: string, currentUrl: string, lat: string, lng: string): Observable<any> {
    return this.http.get<any[]>(api + "/" + currentUrl + "/" + lat + "/" + lng);
  }

  emptyProductCart(url: string, email: string) {
    return this.http.post<any>(url + "/" + email + "/" + this.currentUrl, { responseType: "text" });
  }

  getOrderDetailsByOrderNo(url: string, orderNo: string) {
    return this.http.get<any>(url + "/" + orderNo, { responseType: "json" });
  }

  setOrderSummary(summary: OrderSummary) {
    this.orderSummary = summary;
  }
  getOrderSummary() {
    return this.orderSummary;
  }

  setPincode(pincode: number) {
    this.pincode = pincode;
  }
  getPincode() {
    return this.pincode;
  }

  getOfferDetails(url: string, locId: any, productCode: number[], currentUrl: string) {
    return this.http.get<any>(
      url + "/" + locId + "/" + productCode + "/" + currentUrl
    );
  }

  getOfferAllowFor(url: string, currentUrl: string, type: string) {
    return this.http.get<any>(url + "/" + currentUrl + "/" + type);
  }

  getWebOrderDesigns(url: string, subGroupCode: number, currentUrl: string) {
    return this.http.get<any>(
      url + "/" + subGroupCode + "/" + currentUrl
    );
  }

  getProductOfferDetails(url: string, offerId: string, qty: number) {
    return this.http.get<Product>(url + "/" + offerId + "/" + qty);
  }

  addToCartWithOffer(product: Product, offerProduct: Product, design: Product): void {
    this.googleCustomer = JSON.parse(this.localStorage.getItem("google_loggedIn_details"));
    let locationCode: number = JSON.parse(this.localStorage.getItem("location_code"));

    const cartProducts: Product[] = JSON.parse(this.localStorage.getItem("avct_item")) || [];

    if (cartProducts.some((temp) => temp.product_Code == product.product_Code)) {
      this.toastrService.showErrorToast(product.product_Name + " is already added to cart");
      return;
    } else {
      //design extra variable
      if (design) {
        product.designProductCode = design.product_Code;
        product.designProductName = design.product_Name;
        product.designProductPicture = design.product_Picture;
        product.designProductNetSalePrice = design.net_Sale_Price;
      }
      cartProducts.push(product);
      if (offerProduct)
        cartProducts.push(offerProduct);

      //Design
      if (design && design.designForProductCode) {
        design.orderQuantity = 1;
        design.discountAmt = 0;
        if (design.cartProductType == "Product") {
          design.basePremiumFlavourPrice = 0;
          design.premiumFlavourPrice = 0;
        }
        var taxableAmt = design.sale_Price - (design.sale_Price * design.discountAmt) / 100;
        taxableAmt = taxableAmt + design.basePremiumFlavourPrice;
        var cgst = (design.tax.taxRate / 2 / 100) * taxableAmt;
        design.cgstAmt = cgst;
        var sgst = (design.tax.taxRate / 2 / 100) * taxableAmt;
        design.sgstAmt = sgst;
        design.taxAmount = cgst + sgst; //Tax Amount
        design.cessAmount = (design.cess.cessRate / 100) * taxableAmt;
        let index = cartProducts.findIndex(e => e.product_Code === product.product_Code && !e.designForProductCode);
        let offerIndex = cartProducts.findIndex(e => e.freeByProductCode === product.product_Code);
        if (offerIndex >= 0)
          cartProducts.splice(index + 2, 0, design);
        else
          cartProducts.splice(index + 1, 0, design);
      }
    }

    var productList: any = [];
    if (this.googleCustomer != null) {
      cartProducts.forEach((element) => {
        element.status = "Not placed";
        if (element.cartProductType == "Product") {
          productList.push(element);
        }
      });
    }
    console.log(productList);

    this.cartDetails.status = "Not placed";
    this.cartDetails.logInCustomerEmail = this.googleCustomer?.email;
    this.cartDetails.locationCode = locationCode;
    this.cartDetails.currentUrl = this.currentUrl;
    this.cartDetails.product = productList;

    if (productList.length != 0 && this.googleCustomer != null) {
      this.cartSetUpSubscription = this.insertCartSetUp(this.apiFactory.insertProductCart, this.cartDetails)
        .subscribe((response: any) => {
        });
    }
    this.toastrService.wait("Adding Product to Cart", product.product_Name + " added to cart");
    this.localStorage.setItem("avct_item", JSON.stringify(cartProducts));
  }

  getProductDiscountDetails(url: string, offerId: string, qty: number) {
    return this.http.get<number>(url + "/" + offerId + "/" + qty);
  }

  getProductBulkDiscountDetails(url: string, offerId: string) {
    return this.http.get<BulkDiscountDto>(url + "/" + offerId);
  }
}